import script from "./CopilotPopover.vue?vue&type=script&lang=ts&setup=true"
export * from "./CopilotPopover.vue?vue&type=script&lang=ts&setup=true"

import "./CopilotPopover.vue?vue&type=style&index=0&id=263f851c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-263f851c"]])

export default __exports__